import type { BreakpointProps } from "@/lib/types";

export const BREAKPOINT_KEYS = ["sm", "md", "lg"] as const;
type BreakpointKey = (typeof BREAKPOINT_KEYS)[number];

export function isBreakpointKey(k: string): k is BreakpointKey {
  return (BREAKPOINT_KEYS as readonly string[]).includes(k);
}

export function splitBreakpointProps<T extends Record<string, unknown>>(
  props: T,
) {
  const bp: Partial<BreakpointProps> = {};
  const native: Record<string, unknown> = {};

  for (const k in props) {
    if (isBreakpointKey(k)) {
      (bp as any)[k] = props[k];
    } else {
      native[k] = props[k];
    }
  }

  type Native = Omit<T, keyof BreakpointProps>;

  return { bp: bp as Partial<BreakpointProps>, native: native as Native };
}

export function breakpointClasses(bp?: Partial<BreakpointProps>): string {
  if (!bp) {
    return "";
  }

  const classes = [bp.sm, bp.md, bp.lg].filter(Boolean) as string[];

  return classes.join(" ");
}
